import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'

export const staticPages = [
  allRoutes.privacyPolicy,
  allRoutes.gdprCompilance,
  allRoutes.termsAndConditions,
  allRoutes.affiliate,
  allRoutes.writeForUs,
  allRoutes.dmca,
  allRoutes.disclaimer,
  allRoutes.copyrightsNotice,
  allRoutes.aboutUs,
  allRoutes.careers,
  allRoutes.contactUs,
  allRoutes.feedback,
  allRoutes.signIn,
  allRoutes.signUp,
  allRoutes.forgotPassword,
  allRoutes.profile,
  allRoutes.profileEdit,
  allRoutes.saveForLater,
  allRoutes.changePassword
]
